import { render } from "./DbConnectionModuleProperties.vue?vue&type=template&id=de4e65ac&scoped=true"
import script from "./DbConnectionModuleProperties.vue?vue&type=script&lang=js"
export * from "./DbConnectionModuleProperties.vue?vue&type=script&lang=js"

import "./DbConnectionModuleProperties.vue?vue&type=style&index=0&id=de4e65ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4e65ac"]])

export default __exports__